import { IFormInputProps } from '../../components/merchants/FormInput';
import { InputType } from '../../components/form/form-input-constants';
import { PROVIDER_FORM_FIELD_NAMES, PROVIDER_FORM_FIELDS } from './provider-form';

export const MAIN_PROVIDER_INPUTS = ({ t, whiteLabelPartnersList, processorPlatformList, mccList }): IFormInputProps[] => [
  {
    key: PROVIDER_FORM_FIELDS.PARTNER_ID,
    fieldName: PROVIDER_FORM_FIELDS.PARTNER_ID,
    placeholder: t(PROVIDER_FORM_FIELD_NAMES.PARTNER_ID),
    label: t(PROVIDER_FORM_FIELD_NAMES.PARTNER_ID),
    inputType: InputType.Select,
    data: whiteLabelPartnersList,
    additionalClasses: 'col-sx-3 col-md-3',
    required: true,
    autoComplete: 'off'
  },
  {
    key: PROVIDER_FORM_FIELDS.NAME,
    fieldName: PROVIDER_FORM_FIELDS.NAME,
    placeholder: t(PROVIDER_FORM_FIELD_NAMES.NAME),
    label: t(PROVIDER_FORM_FIELD_NAMES.NAME),
    inputType: InputType.Text,
    additionalClasses: 'col-sx-3 col-md-3',
    required: true,
    autoComplete: 'off'
  },
  {
    key: PROVIDER_FORM_FIELDS.PROCESSOR_PLATFORM,
    fieldName: PROVIDER_FORM_FIELDS.PROCESSOR_PLATFORM,
    placeholder: t(PROVIDER_FORM_FIELD_NAMES.PROCESSOR_PLATFORM),
    label: t(PROVIDER_FORM_FIELD_NAMES.PROCESSOR_PLATFORM),
    inputType: InputType.Select,
    data: processorPlatformList,
    searchable: false,
    additionalClasses: 'col-sx-3 col-md-3',
    required: true,
    autoComplete: 'off'
  },
  {
    key: PROVIDER_FORM_FIELDS.MCC,
    fieldName: PROVIDER_FORM_FIELDS.MCC,
    placeholder: t(PROVIDER_FORM_FIELD_NAMES.MCC),
    label: t(PROVIDER_FORM_FIELD_NAMES.MCC),
    inputType: InputType.Select,
    data: mccList,
    additionalClasses: 'col-sx-3 col-md-3',
    required: true,
  },
  {
    key: PROVIDER_FORM_FIELDS.PROCESSOR_ID,
    fieldName: PROVIDER_FORM_FIELDS.PROCESSOR_ID,
    placeholder: t(PROVIDER_FORM_FIELD_NAMES.PROCESSOR_ID),
    label: t(PROVIDER_FORM_FIELD_NAMES.PROCESSOR_ID),
    inputType: InputType.Text,
    additionalClasses: 'col-sx-3 col-md-3',
    autoComplete: 'off'
  },
];

export const CAPABILITIES_INPUTS = ({ t, cardBrandsRef, countriesRef, currenciesRef, cardBrandsList, countriesList, currenciesList }): IFormInputProps[] => [
  {
    key: PROVIDER_FORM_FIELDS.CARD_BRANDS,
    fieldName: PROVIDER_FORM_FIELDS.CARD_BRANDS,
    placeholder: t(PROVIDER_FORM_FIELD_NAMES.CARD_BRANDS),
    label: t(PROVIDER_FORM_FIELD_NAMES.CARD_BRANDS),
    inputType: InputType.MultiSelect,
    data: cardBrandsList,
    ref: cardBrandsRef,
    allValue: cardBrandsList?.map(item => item.value),
    placement: 'auto',
    additionalClasses: 'col-sx-3 col-md-3 mb-5',
    required: true,
    autoComplete: 'off'
  },
  {
    key: PROVIDER_FORM_FIELDS.SUPPORTED_COUNTRIES,
    fieldName: PROVIDER_FORM_FIELDS.SUPPORTED_COUNTRIES,
    placeholder: t(PROVIDER_FORM_FIELD_NAMES.SUPPORTED_COUNTRIES),
    label: t(PROVIDER_FORM_FIELD_NAMES.SUPPORTED_COUNTRIES),
    inputType: InputType.MultiSelect,
    data: countriesList,
    ref: countriesRef,
    allValue: countriesList?.map(item => item.value),
    placement: 'auto',
    additionalClasses: 'col-sx-3 col-md-3 mb-5',
    required: true,
    autoComplete: 'off'
  },
  {
    key: PROVIDER_FORM_FIELDS.SUPPORTED_CURRENCIES,
    fieldName: PROVIDER_FORM_FIELDS.SUPPORTED_CURRENCIES,
    placeholder: t(PROVIDER_FORM_FIELD_NAMES.SUPPORTED_CURRENCIES),
    label: t(PROVIDER_FORM_FIELD_NAMES.SUPPORTED_CURRENCIES),
    inputType: InputType.MultiSelect,
    data: currenciesList,
    ref: currenciesRef,
    allValue: currenciesList?.map(item => item.value),
    placement: 'auto',
    additionalClasses: 'col-sx-3 col-md-3 mb-5',
    required: true,
    autoComplete: 'off'
  },
];

export const CAPABILITIES_CHECKBOXES = [
  {
    label: PROVIDER_FORM_FIELD_NAMES.SUPPORT_3DS,
    fieldName: PROVIDER_FORM_FIELDS.SUPPORT_3DS,
  },
  {
    label: PROVIDER_FORM_FIELD_NAMES.SUPPORT_3DS2,
    fieldName: PROVIDER_FORM_FIELDS.SUPPORT_3DS2,
  },
  {
    label: PROVIDER_FORM_FIELD_NAMES.SUPPORT_CIT,
    fieldName: PROVIDER_FORM_FIELDS.SUPPORT_CIT,
  },
  {
    label: PROVIDER_FORM_FIELD_NAMES.SUPPORT_MIT,
    fieldName: PROVIDER_FORM_FIELDS.SUPPORT_MIT,
  },
  {
    label: PROVIDER_FORM_FIELD_NAMES.USE_DEFAULT_DUP_CHECK_SECONDS,
    fieldName: PROVIDER_FORM_FIELDS.USE_DEFAULT_DUP_CHECK_SECONDS,
  },
  {
    label: PROVIDER_FORM_FIELD_NAMES.USE_DYNAMIC_DESCRIPTOR,
    fieldName: PROVIDER_FORM_FIELDS.USE_DYNAMIC_DESCRIPTOR,
  },
  {
    label: PROVIDER_FORM_FIELD_NAMES.USE_DESCRIPTOR_SUFFIX,
    fieldName: PROVIDER_FORM_FIELDS.USE_DESCRIPTOR_SUFFIX,
  },
  {
    label: PROVIDER_FORM_FIELD_NAMES.SUPPORT_TOKENIZATION,
    fieldName: PROVIDER_FORM_FIELDS.SUPPORT_TOKENIZATION,
  },
  {
    label: PROVIDER_FORM_FIELD_NAMES.SUPPORT_NETWORK_TOKENIZATION,
    fieldName: PROVIDER_FORM_FIELDS.SUPPORT_NETWORK_TOKENIZATION,
  },
  {
    label: PROVIDER_FORM_FIELD_NAMES.SUPPORT_NETWORK_TOKENIZATION_3DS,
    fieldName: PROVIDER_FORM_FIELDS.SUPPORT_NETWORK_TOKENIZATION_3DS,
  },
  {
    label: PROVIDER_FORM_FIELD_NAMES.SUPPORT_STANDALONE_REFUND,
    fieldName: PROVIDER_FORM_FIELDS.SUPPORT_STANDALONE_REFUND,
  },
  {
    label: PROVIDER_FORM_FIELD_NAMES.SUPPORT_EXTERNAL_NETWORK_TOKEN_PAYMENT,
    fieldName: PROVIDER_FORM_FIELDS.SUPPORT_EXTERNAL_NETWORK_TOKEN_PAYMENT,
  },

];

export const PAYSAFE_CONFIG_INPUTS = ({ t }): IFormInputProps[] => [
  {
    key: PROVIDER_FORM_FIELDS.USER,
    fieldName: PROVIDER_FORM_FIELDS.USER,
    placeholder: t(PROVIDER_FORM_FIELD_NAMES.USER),
    label: t(PROVIDER_FORM_FIELD_NAMES.USER),
    inputType: InputType.Text,
    additionalClasses: 'col-sx-3 col-md-3',
    required: true,
    autoComplete: 'off'
  },
  {
    key: PROVIDER_FORM_FIELDS.PASSWORD,
    fieldName: PROVIDER_FORM_FIELDS.PASSWORD,
    placeholder: t(PROVIDER_FORM_FIELD_NAMES.PASSWORD),
    label: t(PROVIDER_FORM_FIELD_NAMES.PASSWORD),
    inputType: InputType.Text,
    additionalClasses: 'col-sx-3 col-md-3',
    required: true,
    autoComplete: 'off'
  },
  {
    key: PROVIDER_FORM_FIELDS.ACCOUNT_ID,
    fieldName: PROVIDER_FORM_FIELDS.ACCOUNT_ID,
    placeholder: t(PROVIDER_FORM_FIELD_NAMES.ACCOUNT_ID),
    label: t(PROVIDER_FORM_FIELD_NAMES.ACCOUNT_ID),
    inputType: InputType.Text,
    additionalClasses: 'col-sx-3 col-md-3',
    required: true,
    autoComplete: 'off'
  },
];
export const CHECKOUT_CONFIG_INPUTS = ({ t }): IFormInputProps[] => [
  {
    key: PROVIDER_FORM_FIELDS.PROCESSING_CHANNEL_ID,
    fieldName: PROVIDER_FORM_FIELDS.PROCESSING_CHANNEL_ID,
    placeholder: t(PROVIDER_FORM_FIELD_NAMES.PROCESSING_CHANNEL_ID),
    label: t(PROVIDER_FORM_FIELD_NAMES.PROCESSING_CHANNEL_ID),
    inputType: InputType.Text,
    additionalClasses: 'col-sx-3 col-md-3',
    required: true,
    autoComplete: 'off'
  },
  {
    key: PROVIDER_FORM_FIELDS.PUBLIC_KEY,
    fieldName: PROVIDER_FORM_FIELDS.PUBLIC_KEY,
    placeholder: t(PROVIDER_FORM_FIELD_NAMES.PUBLIC_KEY),
    label: t(PROVIDER_FORM_FIELD_NAMES.PUBLIC_KEY),
    inputType: InputType.Text,
    additionalClasses: 'col-sx-12 col-md-12',
    required: true,
    autoComplete: 'off'
  },
  {
    key: PROVIDER_FORM_FIELDS.SECRET_KEY,
    fieldName: PROVIDER_FORM_FIELDS.SECRET_KEY,
    placeholder: t(PROVIDER_FORM_FIELD_NAMES.SECRET_KEY),
    label: t(PROVIDER_FORM_FIELD_NAMES.SECRET_KEY),
    inputType: InputType.Text,
    additionalClasses: 'col-sx-12 col-md-12',
    required: true,
    autoComplete: 'off'
  },
  {
    key: PROVIDER_FORM_FIELDS.ACCOUNT_UPDATER_PRIVATE_KEY,
    fieldName: PROVIDER_FORM_FIELDS.ACCOUNT_UPDATER_PRIVATE_KEY,
    placeholder: t(PROVIDER_FORM_FIELD_NAMES.ACCOUNT_UPDATER_PRIVATE_KEY),
    label: t(PROVIDER_FORM_FIELD_NAMES.ACCOUNT_UPDATER_PRIVATE_KEY),
    inputType: InputType.Text,
    additionalClasses: 'col-sx-12 col-md-12',
    autoComplete: 'off'
  },
];
export const NMI_CONFIG_INPUTS = ({ t }): IFormInputProps[] => [
  {
    key: PROVIDER_FORM_FIELDS.SECRET_KEY,
    fieldName: PROVIDER_FORM_FIELDS.SECRET_KEY,
    placeholder: t(PROVIDER_FORM_FIELD_NAMES.SECRET_KEY),
    label: t(PROVIDER_FORM_FIELD_NAMES.SECRET_KEY),
    inputType: InputType.Text,
    additionalClasses: 'col-sx-12 col-md-12',
    required: true,
    autoComplete: 'off'
  },
];
export const RAPYD_CONFIG_INPUTS = ({ t, currenciesList, supportCurrencyRef }): IFormInputProps[] => [
  {
    key: PROVIDER_FORM_FIELDS.ACCESS_KEY,
    fieldName: PROVIDER_FORM_FIELDS.ACCESS_KEY,
    placeholder: t(PROVIDER_FORM_FIELD_NAMES.ACCESS_KEY),
    label: t(PROVIDER_FORM_FIELD_NAMES.ACCESS_KEY),
    inputType: InputType.Text,
    additionalClasses: 'col-sx-12 col-md-12',
    required: true,
    autoComplete: 'off'
  },
  {
    key: PROVIDER_FORM_FIELDS.SECRET_KEY,
    fieldName: PROVIDER_FORM_FIELDS.SECRET_KEY,
    placeholder: t(PROVIDER_FORM_FIELD_NAMES.SECRET_KEY),
    label: t(PROVIDER_FORM_FIELD_NAMES.SECRET_KEY),
    inputType: InputType.Text,
    additionalClasses: 'col-sx-12 col-md-12',
    required: true,
    autoComplete: 'off'
  },
  {
    key: PROVIDER_FORM_FIELDS.WALLET_ID,
    fieldName: PROVIDER_FORM_FIELDS.WALLET_ID,
    placeholder: t(PROVIDER_FORM_FIELD_NAMES.WALLET_ID),
    label: t(PROVIDER_FORM_FIELD_NAMES.WALLET_ID),
    inputType: InputType.Text,
    additionalClasses: 'col-sx-3 col-md-3',
    required: true,
    autoComplete: 'off'
  },
  {
    key: PROVIDER_FORM_FIELDS.BALANCE_CURRENCY,
    fieldName: PROVIDER_FORM_FIELDS.BALANCE_CURRENCY,
    placeholder: t(PROVIDER_FORM_FIELD_NAMES.BALANCE_CURRENCY),
    label: t(PROVIDER_FORM_FIELD_NAMES.BALANCE_CURRENCY),
    inputType: InputType.Select,
    data: currenciesList,
    placement: 'auto',
    additionalClasses: 'col-sx-3 col-md-3',
    required: true,
    autoComplete: 'off'
  },
  {
    key: PROVIDER_FORM_FIELDS.CONFIG_SUPPORTED_CURRENCIES,
    fieldName: PROVIDER_FORM_FIELDS.CONFIG_SUPPORTED_CURRENCIES,
    placeholder: t(PROVIDER_FORM_FIELD_NAMES.CONFIG_SUPPORTED_CURRENCIES),
    label: t(PROVIDER_FORM_FIELD_NAMES.CONFIG_SUPPORTED_CURRENCIES),
    inputType: InputType.MultiSelect,
    data: currenciesList,
    ref: supportCurrencyRef,
    allValue: currenciesList?.map(item => item.value),
    placement: 'auto',
    additionalClasses: 'col-sx-3 col-md-3',
    required: true,
    autoComplete: 'off'
  },
];

export const REVOLUT_CONFIG_INPUTS = ({ t, processorList }): IFormInputProps[] => [
  {
    key: PROVIDER_FORM_FIELDS.PROCESSOR,
    fieldName: PROVIDER_FORM_FIELDS.PROCESSOR,
    placeholder: t(PROVIDER_FORM_FIELD_NAMES.PROCESSOR),
    label: t(PROVIDER_FORM_FIELD_NAMES.PROCESSOR),
    inputType: InputType.Select,
    data: processorList,
    searchable: false,
    cleanable: false,
    additionalClasses: 'col-sx-6 col-md-6',
    required: true,
    autoComplete: 'off'
  },

  {
    key: PROVIDER_FORM_FIELDS.CLIENT_ID,
    fieldName: PROVIDER_FORM_FIELDS.CLIENT_ID,
    placeholder: t(PROVIDER_FORM_FIELD_NAMES.CLIENT_ID),
    label: t(PROVIDER_FORM_FIELD_NAMES.CLIENT_ID),
    inputType: InputType.Text,
    additionalClasses: 'col-sx-6 col-md-6',
    required: true,
    autoComplete: 'off'
  },
  {
    key: PROVIDER_FORM_FIELDS.STATIC_KEY,
    fieldName: PROVIDER_FORM_FIELDS.STATIC_KEY,
    placeholder: t(PROVIDER_FORM_FIELD_NAMES.STATIC_KEY),
    label: t(PROVIDER_FORM_FIELD_NAMES.STATIC_KEY),
    inputType: InputType.Text,
    additionalClasses: 'col-sx-12 col-md-12',
    required: true,
    autoComplete: 'off'
  },
  {
    key: PROVIDER_FORM_FIELDS.SECRET_KEY,
    fieldName: PROVIDER_FORM_FIELDS.SECRET_KEY,
    placeholder: t(PROVIDER_FORM_FIELD_NAMES.SECRET_KEY),
    label: t(PROVIDER_FORM_FIELD_NAMES.SECRET_KEY),
    inputType: InputType.Text,
    additionalClasses: 'col-sx-12 col-md-12',
    autoComplete: 'off'
  },
  {
    key: PROVIDER_FORM_FIELDS.WEBHOOK_URL,
    fieldName: PROVIDER_FORM_FIELDS.WEBHOOK_URL,
    placeholder: t(PROVIDER_FORM_FIELD_NAMES.WEBHOOK_URL),
    label: t(PROVIDER_FORM_FIELD_NAMES.WEBHOOK_URL),
    inputType: InputType.Text,
    additionalClasses: 'col-sx-12 col-md-12',
    autoComplete: 'off'
  },
  {
    key: PROVIDER_FORM_FIELDS.WEBHOOK_SECRET,
    fieldName: PROVIDER_FORM_FIELDS.WEBHOOK_SECRET,
    placeholder: t(PROVIDER_FORM_FIELD_NAMES.WEBHOOK_SECRET),
    label: t(PROVIDER_FORM_FIELD_NAMES.WEBHOOK_SECRET),
    inputType: InputType.Text,
    additionalClasses: 'col-sx-12 col-md-12',
    autoComplete: 'off'
  },

];

export const ADYEN_CONFIG_INPUTS = ({ t }): IFormInputProps[] => [
  {
    key: PROVIDER_FORM_FIELDS.API_KEY,
    fieldName: PROVIDER_FORM_FIELDS.API_KEY,
    placeholder: t(PROVIDER_FORM_FIELD_NAMES.API_KEY),
    label: t(PROVIDER_FORM_FIELD_NAMES.API_KEY),
    inputType: InputType.Text,
    additionalClasses: 'col-sx-12 col-md-12',
    required: true,
    autoComplete: 'off'
  },
  {
    key: PROVIDER_FORM_FIELDS.WEBHOOK_HMAC_KEY,
    fieldName: PROVIDER_FORM_FIELDS.WEBHOOK_HMAC_KEY,
    placeholder: t(PROVIDER_FORM_FIELD_NAMES.WEBHOOK_HMAC_KEY),
    label: t(PROVIDER_FORM_FIELD_NAMES.WEBHOOK_HMAC_KEY),
    inputType: InputType.Text,
    additionalClasses: 'col-sx-12 col-md-12',
    required: true,
    autoComplete: 'off'
  },
  {
    key: PROVIDER_FORM_FIELDS.MERCHANT_ACCOUNT,
    fieldName: PROVIDER_FORM_FIELDS.MERCHANT_ACCOUNT,
    placeholder: t(PROVIDER_FORM_FIELD_NAMES.MERCHANT_ACCOUNT),
    label: t(PROVIDER_FORM_FIELD_NAMES.MERCHANT_ACCOUNT),
    inputType: InputType.Text,
    additionalClasses: 'col-sx-12 col-md-6',
    required: true,
    autoComplete: 'off'
  },
  {
    key: PROVIDER_FORM_FIELDS.CONFIG_MCC,
    fieldName: PROVIDER_FORM_FIELDS.CONFIG_MCC,
    placeholder: t(PROVIDER_FORM_FIELD_NAMES.CONFIG_MCC),
    label: t(PROVIDER_FORM_FIELD_NAMES.CONFIG_MCC),
    inputType: InputType.Text,
    additionalClasses: 'col-sx-12 col-md-6',
    required: true,
    autoComplete: 'off'
  },
];

export const BRAINTREE_CONFIG_INPUTS = ({ t }): IFormInputProps[] => [
  {
    key: PROVIDER_FORM_FIELDS.MERCHANT_ID,
    fieldName: PROVIDER_FORM_FIELDS.MERCHANT_ID,
    placeholder: t(PROVIDER_FORM_FIELD_NAMES.MERCHANT_ID),
    label: t(PROVIDER_FORM_FIELD_NAMES.MERCHANT_ID),
    inputType: InputType.Text,
    additionalClasses: 'col-sx-12 col-md-3',
    required: true,
    autoComplete: 'off'
  },
  {
    key: PROVIDER_FORM_FIELDS.PUBLIC_KEY,
    fieldName: PROVIDER_FORM_FIELDS.PUBLIC_KEY,
    placeholder: t(PROVIDER_FORM_FIELD_NAMES.PUBLIC_KEY),
    label: t(PROVIDER_FORM_FIELD_NAMES.PUBLIC_KEY),
    inputType: InputType.Text,
    additionalClasses: 'col-sx-12 col-md-3',
    required: true,
    autoComplete: 'off'
  },
  {
    key: PROVIDER_FORM_FIELDS.PRIVATE_KEY,
    fieldName: PROVIDER_FORM_FIELDS.PRIVATE_KEY,
    placeholder: t(PROVIDER_FORM_FIELD_NAMES.PRIVATE_KEY),
    label: t(PROVIDER_FORM_FIELD_NAMES.PRIVATE_KEY),
    inputType: InputType.Text,
    additionalClasses: 'col-sx-12 col-md-6',
    required: true,
    autoComplete: 'off'
  },
];

export const STRIPE_CONFIG_INPUTS = ({ t }): IFormInputProps[] => [
  {
    key: PROVIDER_FORM_FIELDS.API_KEY,
    fieldName: PROVIDER_FORM_FIELDS.API_KEY,
    placeholder: t(PROVIDER_FORM_FIELD_NAMES.API_KEY),
    label: t(PROVIDER_FORM_FIELD_NAMES.API_KEY),
    inputType: InputType.Text,
    additionalClasses: 'col-sx-12 col-md-12',
    required: true,
    autoComplete: 'off'
  },
  {
    key: PROVIDER_FORM_FIELDS.WEBHOOK_SECRET,
    fieldName: PROVIDER_FORM_FIELDS.WEBHOOK_SECRET,
    placeholder: t(PROVIDER_FORM_FIELD_NAMES.WEBHOOK_SECRET),
    label: t(PROVIDER_FORM_FIELD_NAMES.WEBHOOK_SECRET),
    inputType: InputType.Text,
    additionalClasses: 'col-sx-12 col-md-12',
    required: true,
    autoComplete: 'off'
  },
  {
    key: PROVIDER_FORM_FIELDS.CLIENT_ID,
    fieldName: PROVIDER_FORM_FIELDS.CLIENT_ID,
    placeholder: t(PROVIDER_FORM_FIELD_NAMES.CLIENT_ID),
    label: t(PROVIDER_FORM_FIELD_NAMES.CLIENT_ID),
    inputType: InputType.Text,
    additionalClasses: 'col-sx-6 col-md-4',
    required: true,
    autoComplete: 'off'
  },
  {
    key: PROVIDER_FORM_FIELDS.APP_NAME,
    fieldName: PROVIDER_FORM_FIELDS.APP_NAME,
    placeholder: t(PROVIDER_FORM_FIELD_NAMES.APP_NAME),
    label: t(PROVIDER_FORM_FIELD_NAMES.APP_NAME),
    inputType: InputType.Text,
    additionalClasses: 'col-sx-6 col-md-4',
    required: true,
    autoComplete: 'off'
  },
  {
    key: PROVIDER_FORM_FIELDS.APP_VERSION,
    fieldName: PROVIDER_FORM_FIELDS.APP_VERSION,
    placeholder: t(PROVIDER_FORM_FIELD_NAMES.APP_VERSION),
    label: t(PROVIDER_FORM_FIELD_NAMES.APP_VERSION),
    inputType: InputType.Text,
    additionalClasses: 'col-sx-6 col-md-4',
    required: true,
    autoComplete: 'off'
  },
];

export const USIO_CONFIG_INPUTS = ({ t }): IFormInputProps[] => [
  {
    key: PROVIDER_FORM_FIELDS.MERCHANT_ID,
    fieldName: PROVIDER_FORM_FIELDS.MERCHANT_ID,
    placeholder: t(PROVIDER_FORM_FIELD_NAMES.MERCHANT_ID),
    label: t(PROVIDER_FORM_FIELD_NAMES.MERCHANT_ID),
    inputType: InputType.Text,
    additionalClasses: 'col-sx-3 col-md-3',
    required: true,
    autoComplete: 'off'
  },
  {
    key: PROVIDER_FORM_FIELDS.LOGIN,
    fieldName: PROVIDER_FORM_FIELDS.LOGIN,
    placeholder: t(PROVIDER_FORM_FIELD_NAMES.LOGIN),
    label: t(PROVIDER_FORM_FIELD_NAMES.LOGIN),
    inputType: InputType.Text,
    additionalClasses: 'col-sx-3 col-md-3',
    required: true,
    autoComplete: 'off'
  },
  {
    key: PROVIDER_FORM_FIELDS.PASSWORD,
    fieldName: PROVIDER_FORM_FIELDS.PASSWORD,
    placeholder: t(PROVIDER_FORM_FIELD_NAMES.PASSWORD),
    label: t(PROVIDER_FORM_FIELD_NAMES.PASSWORD),
    inputType: InputType.Text,
    additionalClasses: 'col-sx-3 col-md-3',
    required: true,
    autoComplete: 'off'
  },
];
